import wretch from 'wretch';
import queryString from 'wretch/addons/queryString';

// API URL constants
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUTH_API_URL = '/authorization';
export const CLINICAL_POLICY_API_URL = '/clinicalpolicy';
export const INTAKE_CASE_API_URL = '/intake-case';
export const REFERENCE_API_URL = '/reference';
export const SCOPE_ASSESSOR_API_URL = '/scope-assessor';
export const TREATMENT_API_URL = '/treatment';
export const EPA_API_URL = '/epa/cases';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = { base: wretch(process.env.REACT_APP_BASE_URL).addon(queryString) };
